import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ServiceType,
  EnterpriseSearchService,
  FlightExtrasOptions
} from '@sabstravtech/obtservices/angular';
import { FlightBasketDetails } from '../../core/interfaces/flight-basket-details';

import { FlightEnterpriseSearchInterface, ServiceProvider } from '@sabstravtech/obtservices/base';
@Component({
  selector: 'app-show-details-flight',
  templateUrl: './show-details-flight.component.html',
  styleUrls: ['./show-details-flight.component.scss'],
  standalone: false
})
export class ShowDetailsFlightComponent implements OnInit {
  @Input() flightDetails: FlightBasketDetails;
  @Input() detail: any;
  @Input() originalJourney: any;
  @Input() isMyBooking = false;
  @Input() serviceName: ServiceProvider = null;
  @Output() openFareRules: EventEmitter<void> = new EventEmitter<void>();

  showDetails = false;
  public searchParams: FlightEnterpriseSearchInterface;
  displayFlightExtras: FlightExtrasOptions[] = [];
  displayBaggageAllowance: FlightExtrasOptions[] = [];
  displayAdvancedAncillaryOptions: FlightExtrasOptions[] = [];
  constructor(private searchService: EnterpriseSearchService) {}

  ngOnInit(): void {
    this.searchParams = this.searchService.searches[ServiceType.Flight];
    const additional = this.flightDetails?.additional;
    this.displayFlightExtras = additional?.flightExtras?.filter((e) => e?.text) || [];
    this.displayBaggageAllowance = additional?.baggageAllowance?.filter((e) => e?.text) || [];
    this.displayAdvancedAncillaryOptions =
      additional?.advancedAncillaryOptions?.filter((e) => e?.text) || [];

    const isTFX = this.serviceName === (ServiceProvider.Travelfusion as string);
    const isInbound = this.detail?.inboundFlights?.some((f) => f.id === this.flightDetails?.id);
    if (isTFX && isInbound) {
      const outboundAdditional = this.detail?.outboundFlights?.[0]?.additional;
      if (!this.displayFlightExtras.length && outboundAdditional?.flightExtras?.length) {
        this.displayFlightExtras = outboundAdditional.flightExtras.filter((e) => e?.text);
      }
      if (
        outboundAdditional?.luggagePerBooking &&
        !this.displayBaggageAllowance.length &&
        outboundAdditional?.baggageAllowance?.length
      ) {
        this.displayBaggageAllowance = outboundAdditional.baggageAllowance.filter((e) => e?.text);
      }
      if (
        outboundAdditional?.ancillaryPerBooking &&
        !this.displayAdvancedAncillaryOptions.length &&
        outboundAdditional?.advancedAncillaryOptions?.length
      ) {
        this.displayAdvancedAncillaryOptions = outboundAdditional.advancedAncillaryOptions.filter(
          (e) => e?.text
        );
      }
    }
  }
}
